/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { Grid, Skeleton } from "@mantine/core";
import { loadingStates } from "../utilities/utilities";
import { Paperclip } from "tabler-icons-react";
import { useNavigate } from "react-router-dom";
import { apiWrapWithErrorWithData } from "../utilities/apiHelpers"; // Import the necessary functions
import {
  tasksAnalytics,
  AgreementManagerAnalytics,
} from "../utilities/apis/tasks"; // Import the necessary functions
import DashboardAgreementsManager1 from "./DashboardAgreementsManager1";
import "./DashboardAgreementsManager.css";
import renewals from "./ImagesDashboard/renewals.png";
import total_img from "./ImagesDashboard/total_contract.png";
import review from "./ImagesDashboard/review.png";
import signed from "./ImagesDashboard/signed.png";
import signing_status from "./ImagesDashboard/signing_status.png";
import approval_status from "./ImagesDashboard/approval_status.png";
import e_stamps from "./ImagesDashboard/e_stamps.png";
import { selectUserData } from "../redux/selectors";
import { useSelector } from "react-redux";
import { showNotification } from "@mantine/notifications";
import {
  SIgnedDocIcon,
  TemplatesIcon,
  ReviewIcon,
  RenewIcon,
  EstampsIcon,
  ApproveIcon,
  MyBagIcon,
  SIgnatureStageIcon,
  MyBagIcon2,
} from "../icons/new-icons/icon";

const DashboardAgreementsManager = ({ month = 0 }) => {
  const navigate = useNavigate();

  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser.loginAs;

  console.log("User right now logged in as", loginAs);

  const [BoxData, setBoxData] = useState([
    {
      title: "All Contracts",
      route: "total-agreements",
      color: "red-400",
      Icon: MyBagIcon2,
    },
    {
      title: "Review Stage",
      route: "review-status",
      color: "blue-900",
      Icon: ReviewIcon,
    },
    {
      title: "Approval Stage",
      route: "approval-status",
      color: "purple-900",
      Icon: ApproveIcon,
    },
    {
      title: "Signature Stage",
      route: "signature-status",
      color: "green-900",
      Icon: SIgnatureStageIcon,
    },
    {
      title: "Signed",
      route: "signed",
      color: "pink-900",
      Icon: SIgnedDocIcon,
    },
    {
      title: "Renewals/Expirations",
      route: "renewals",
      Icon: RenewIcon,
    },
    {
      title: "e-Stamps",
      route: "estamps",
      Icon: EstampsIcon,
    },
  ]);

  const fetchAgrManagerAnalytics = async () => {
    const resp = await apiWrapWithErrorWithData(AgreementManagerAnalytics());
    if (resp?.success && resp?.analytics) {
      const analytics = resp?.analytics;

      // Update the state using the functional update pattern to ensure we use the latest BoxData
      setBoxData((prevBoxData) =>
        prevBoxData.map((box) => {
          let statusKey = "";
          switch (box.title) {
            case "All Contracts":
              statusKey = "Total";
              break;
            case "Review Stage":
              statusKey = "Reviewer";
              break;
            case "Signature Stage":
              statusKey = "Sign-Auth";
              break;
            case "Approval Stage":
              statusKey = "Approver";
              break;
            case "Signed":
              statusKey = "Signed";
              break;
            case "initiator status":
              statusKey = "Initiator";
              break;
            case "editor status":
              statusKey = "Editor";
              break;
            default:
              statusKey = null;
          }

          if (statusKey) {
            const data = analytics.find((ele) => ele.status === statusKey);
            return { ...box, value: data ? data.count + "" : "0" };
          }
          return box;
        }),
      );
    }
  };

  useEffect(() => {
    fetchAgrManagerAnalytics();
  }, []);

  const handleBoxClick = (box) => {
    const { route, title } = box;

    // Handle special routes
    if (route === "renewals")
      return navigate("/app/agreements_manager/renewals");
    if (route === "estamps") return navigate("/app/agreements_manager/estamps");

    // Access control
    const accessRules = {
      "total-agreements": [1, 2, 3, 4, 5, 6, 7],
      "review-status": [1, 2, 4, 5],
      "signature-status": [1, 2, 3, 4, 7],
      "approval-status": [1, 2, 4, 6],
      signed: [1, 2, 3, 4],
    };

    const allowedIds = accessRules[route];
    if (allowedIds && allowedIds.includes(loginAs?.id)) {
      navigate(`/app/agreements_manager/${route}`);
    } else {
      showNotification({
        color: "red",
        title: "Access",
        message: "You Do not have Access!",
      });
    }
  };

  const [configs, setConfigs] = useState({
    loading: loadingStates.NO_ACTIVE_REQUEST,
    data: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      setConfigs({ ...configs, loading: loadingStates.LOADING });
      try {
        const resp = await apiWrapWithErrorWithData(tasksAnalytics({ month }));
        if (resp?.success && resp?.analytics) {
          setConfigs({
            ...configs,
            data: resp.analytics,
            loading: loadingStates.NO_ACTIVE_REQUEST,
          });
        } else {
          // showNotification({
          //   color: 'red',
          //   title: 'Case Analytics',
          //   message: 'Failed to load case analytics.',
          // });
          setConfigs({ ...configs, loading: loadingStates.NO_ACTIVE_REQUEST });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle errors or show a notification
        // showNotification({
        //   color: 'red',
        //   title: 'Error',
        //   message: 'Failed to fetch data.',
        // });
        setConfigs({ ...configs, loading: loadingStates.NO_ACTIVE_REQUEST });
      }
    };

    fetchData();
  }, [month]);

  return (
    <div className="dashboard-wrapper">
      {/* Header */}
      <div className="dashboard-header">
        <div>
          <h1 className="dashboard-heading">Agreements Dashboard</h1>
          <p className="dashboard-subtitle">
            Monitor contracts, approvals, signatures and renewals
          </p>
        </div>
      </div>

      {/* Cards */}
      <div className="dashboard-grid">
        {BoxData.map((box, index) => (
          <div
            key={index}
            className="dashboard-card"
            onClick={() => handleBoxClick(box)}
          >
            <div className="card-icon">
              {box.Icon && <box.Icon size={42} />}
            </div>

            <div className="card-title">{box.title}</div>

            <div className="card-value">{box.value ?? "0"}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardAgreementsManager;
